<template>
    <v-autocomplete
        v-model="prestacion"
        :items="prestaciones"
        label="Selecciona una prestacion"
        :item-title="itemTitlePrestacion"
        return-object
        variant="solo"
        placeholder="Busque prestación por código o descripción"
        auto-select-first="true"
        no-data-text="No se encontraron resultados"
        :menu-props="{width: 200}"
        class="asterisco"
        :loading="cargandoPrestaciones"
        @update:modelValue="prestacionSeleccionada"
        >
    </v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import PrestacionService from '@/api/PrestacionService';

    const prestacionService = new PrestacionService();

    export default {
        data(){
            return {
                prestacion: null,
                prestaciones: [],
                cargandoPrestaciones: false,
            }
        },
        props: {
            tipoSolicitud: {
                type: String,
                default: 'bono-adicional'
            }
        },
        mounted(){
            this.cargarPrestaciones();
        },
        methods: {
            prestacionSeleccionada(){
                this.$emit('prestacion-seleccionada', this.prestacion);
            },
            async cargarPrestaciones(){
                this.cargandoPrestaciones = true;
                const response = this.tipoSolicitud == 'bono-adicional' ? 
                    await prestacionService.getPracticas(this.$store.getters.getObraSocial.id, this.$store.getters.getIdProfesion) : 
                    await prestacionService.getPracticasPesadas(this.$store.getters.getObraSocial.id, this.$store.getters.getIdProfesion);
                if(response.status == 200){
                    this.prestaciones = response.data;
                }
                this.cargandoPrestaciones = false;
            },
            itemTitlePrestacion(item) {
                if (!item) return '';
                if(item.codigo == undefined){
                    return '';
                }
                if(item.codigo != item.codigoTraducido){
                    return `${item.codigo} - ${item.descripcion} - (${item.codigoTraducido} para ${this.$store.getters.getObraSocial.nombre})`;
                }
                return `${item.codigo} - ${item.descripcion}`;
            },
        },
    }
</script>